import deepCleaner from 'deep-cleaner';
import mapJson from 'jsonpath-mapper';
import minimist from 'minimist';
import clone from 'rfdc';
import { MigrateRequest, SourceCms, TargetCms } from '~/services';
import { mapBodyToPayload } from './mapBodyToPayload';

export const mapCliArgsToPayload = (argv: minimist.ParsedArgs) => {
  // Map target args: all args here always scoped to `target-`
  const target: TargetCms = mapJson(argv, {
    url: 'target-url',
    targetProjects: {
      $path: ['target-projects', 'target-project', 'targets'],
      $return: (p: string) => p?.toString().split(','),
    },
    clientId: [`target-clientid`, `target-clientId`],
    sharedSecret: [
      `target-sharedsecret`,
      `target-sharedSecret`,
      `target-secret`,
    ],
    username: 'target-username',
    password: 'target-password',
    language: 'target-language',
  });

  // Map source args: we allow aliases for specifying source args only
  const source: SourceCms = mapJson(argv, {
    url: [`source-url`, 'url'],
    project: [`source-project`, 'project'],
    clientId: [`source-clientid`, `source-clientId`, 'clientid', 'id'],
    sharedSecret: [
      `source-sharedsecret`,
      `source-sharedSecret`,
      `source-secret`,
      'secret',
    ],
    username: [`source-username`, 'u'],
    password: [`source-password`, 'p'],
    language: [`source-language`],
    assetHostname: [
      `source-assethostname`,
      'assethostname',
      'assethost',
      'assets',
      'a',
    ],
  });

  // reuse source as target if only source args supplied
  const sourceIsTarget = Object.entries(target)
    .filter(([k]) => k !== 'targetProjects')
    .every(([, v]) => !v);

  // mapBodyToPayload uses the same payload mapping
  // logic as the REST api
  const payload: MigrateRequest = {
    ...deepCleaner(
      mapBodyToPayload({
        ...argv,
        source,
        target: sourceIsTarget
          ? {
              ...source,
              assetHostname: undefined,
              project: undefined,
              targetProjects: target.targetProjects,
            }
          : target,
        models: argv.models?.toString().split(','),
        outputProgress: true,
      })
    ),
    // map these keys separately so deepCleaner
    // does not remove our intentionally empty arrays
    ...mapJson(argv, {
      components: {
        $path: 'components',
        $return: (c: string) =>
          c
            ?.toString()
            .split(',')
            .filter((id) => id !== '*'),
      },
      contentTypes: {
        $path: ['contentTypes', 'contenttypes', 'content-types'],
        $return: (c: string) =>
          c
            ?.toString()
            .split(',')
            .filter((id) => id !== '*'),
      },
    }),
  };

  return payload;
};

export const mapMutedPayload = (payload: MigrateRequest) =>
  deepCleaner(clone()(payload), ['sharedSecret', 'password']);
